import { FC } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";
import Alert from "react-bootstrap/esm/Alert";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { reportRoute, reportVersionDailyTestCommencementEmailSendRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { useSendDailyTestCommencementEmailMutation } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";

export const SendDailyTestCommencementReportVersionEmailScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionDailyTestCommencementEmailSendRoute);

    const [send, { data, loading, error }] = useSendDailyTestCommencementEmailMutation({
        variables: { reportVersionId: reportVersionGraphId(versionId) },
    });

    return data?.sendDailyTestCommencementEmailReportVersion != null ? (
        <Navigate to={reportRoute.build({ reportId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionDailyTestCommencementEmailSendRoute} />

                {error ? <Alert variant="danger">{error.message}</Alert> : null}

                <Alert variant="info">Do you really want to send the daily test commencement email?</Alert>

                <Button disabled={loading} onClick={() => send()}>
                    Send
                </Button>
            </Container>
        </NavigationScreen>
    );
};
